var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SearchService } from './search-service';
import { getIndex } from './typesense-utils';
import config from '../../../config';
import { queryClient } from '../../../queryClient';
import { queryKeys as sessionQueryKeys } from '../session/query-keys';
var TypesenseSearchService = /** @class */ (function (_super) {
    __extends(TypesenseSearchService, _super);
    function TypesenseSearchService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TypesenseSearchService.prototype.mapResults = function (results) {
        return results.hits;
    };
    TypesenseSearchService.prototype.search = function (payload) {
        var _this = this;
        var user = queryClient.getQueryData(sessionQueryKeys.currentSession());
        var apiKey = user === null || user === void 0 ? void 0 : user.scopedSearchKey;
        var index = getIndex(apiKey, config.typesense.indexDocs);
        return index
            .documents()
            .search(__assign(__assign({}, config.typesense.options), this.buildSearchParams(payload)))
            .then(function (results) { return _this.mapResults(results); });
    };
    return TypesenseSearchService;
}(SearchService));
export { TypesenseSearchService };
